import { SidebarNavItem } from "@/dashboard/models/dashboard-enums";
import { routerModel } from "@/router/router.model";
import { DashboardLinks } from "@/shared/api-contract-internal/api-contract-internal";
import { DashboardSidebarType } from "@/shared/api-contract/getDashboardSidebarIndicatorFlags";
import { useI18n } from "@/shared/composables/use-i18n";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { setup, Vue } from "vue-class-component";
import { Model, Watch } from "vue-property-decorator";
import { vehiclesModel } from "@/shared/vehicles/vehicles.model";
import { EnumCompanyStatus } from "@/shared/api-contract/api-contract";
import { dashboardModel } from "../dashboard.model";
import { appCompanyStatusDialogModel } from "@/shared/components/app-company-status-dialog/app-company-status-dialog.model";
import { sessionModel } from "@/shared/state/session.model";
import { currentCompanyModel } from "@/shared/state/current-company.model";

export class DashboardSidebar extends Vue {
    navItem = SidebarNavItem;
    @Model("modelValue", { default: SidebarNavItem.welcome })
    activeElementId!: SidebarNavItem;
    pageLoader = pageLoaderModel;
    i18n = setup(useI18n);
    authModel = sessionModel;
    indicators: DashboardSidebarType = {} as DashboardSidebarType;
    ctx = setup(() => {
        const logout = () => {
            sessionModel.logout();
            vehiclesModel.resetDefaultFilters();
            routerModel.router.push("/");
        };

        return {
            logout: logout,
        };
    });

    get isApprovedCompany() {
        return (
            currentCompanyModel.companyDto.value &&
            currentCompanyModel.companyDto.value?.status.id === EnumCompanyStatus.APPROVED
        );
    }
    get isProspect() {
        return !sessionModel.JWTUserDto.value?.id_customer;
    }

    get canShowOrdersPage(): boolean {
        return dashboardModel.canShowOrdersPage.value;
    }

    get canShowOrderHistoryPage(): boolean {
        return dashboardModel.canShowOrderHistoryPage.value;
    }

    get canShowFavoritesPage(): boolean {
        return dashboardModel.canShowFavoritesPage.value;
    }

    showCompanyStatusDialog(comingSoon?: boolean): boolean {
        return appCompanyStatusDialogModel.show(comingSoon ? "comingSoon" : "default");
    }

    mounted() {
        /*
            axios.get(http://.....dashboard/indicators)
                .then((res) => this.indicators = res.data)
                .catch((err) => console.log(err))
        */
        this.initFakeIndicators();
    }

    @Watch("activeElementId")
    activeElementIdWatcher(newValue, oldValue) {
        // eslint-disable-next-line
        document.getElementById("mainWrapper")?.classList.remove(oldValue);
        // eslint-disable-next-line
        document.getElementById("mainWrapper")?.classList.add(newValue);
    }

    changeActivity(elementId: SidebarNavItem) {
        this.activeElementId = elementId;
    }

    initFakeIndicators() {
        this.indicators = {
            [DashboardLinks.my_orders]: {
                showNotificationIndicator: false,
            },
            [DashboardLinks.my_documents]: {
                showNotificationIndicator: true,
            },
            [DashboardLinks.my_account]: {
                showNotificationIndicator: true,
            },
            [DashboardLinks.my_company]: {
                showNotificationIndicator: true,
            },
            [DashboardLinks.my_settings]: {
                showNotificationIndicator: false,
            },
            [DashboardLinks.my_favourites]: {
                showNotificationIndicator: true,
            },
        };
    }
}
